var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-selector"},_vm._l((_vm.lang),function(item,index){return _c('div',{key:item.name,staticClass:"item",class:{'selected': item.name === _vm.language},on:{"click":function($event){return _vm.selectLang(item)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }